import { jsx as e, jsxs as f } from "react/jsx-runtime";
import { forwardRef as c, useRef as V, useState as T, useCallback as gt, useEffect as w } from "react";
import { styled as i, css as b, createGlobalStyle as mt } from "styled-components";
const $t = (t) => !!t && !!t && /^[\w\-+.]+@([\w-]+\.)+[\w-]{2,3}$/.test(t), kt = (t) => {
  if (t == null || t === "") return !1;
  const o = Number(t);
  return typeof t == "string" && o >= 0 && Number.isInteger(o);
}, F = i.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  min-height: 16px;
  font-size: 13px;
`, D = i.div`
  display: flex;
`, j = i.p`
  font-weight: 700;
  font-size: 10px;
  line-height: 1;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  white-space: nowrap;
  margin: 0;
`, A = i.div`
  display: flex;
`, wt = i(F)`
  margin-bottom: 0;
  margin-top: 8px;
  min-height: 1em;
  font-size: 16px;
`, Ct = i.div`
  display: flex;
  align-items: center;
`, yt = i.p`
  font-size: 13px;
  line-height: 1;
  letter-spacing: 0.1px;
  color: ${({ theme: t }) => t.colors.red50};
`, P = 8, W = b`
  font-family: inherit;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;

  ${({ theme: { down: t } }) => t("tablet")} {
    font-size: 14px;
  }
`, E = "0px 1px 8px rgba(0, 0, 0, 0.17)", R = "0px 4px 20px rgba(0, 0, 0, 0.07)", G = "0px 4px 28px rgba(0, 0, 0, 0.14)";
b`
  -webkit-filter: blur(0);
  will-change: filter;
  filter: drop-shadow(${E});
`;
b`
  -webkit-filter: blur(0);
  will-change: filter;
  filter: drop-shadow(${R});
`;
b`
  -webkit-filter: blur(0);
  will-change: filter;
  filter: drop-shadow(${G});
`;
b`
  box-shadow: ${E};
  -webkit-filter: blur(0);
  filter: blur(0);
`;
b`
  box-shadow: ${R};
  -webkit-filter: blur(0);
  filter: blur(0);
`;
b`
  box-shadow: ${G};
  -webkit-filter: blur(0);
  filter: blur(0);
`;
const vt = (t, o) => o in t.colors, zt = {
  phoneSm: "320px"
}, Tt = "/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{border-style:none;padding:0}button:-moz-focusring,[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}";
mt`
  ${Tt}

  img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }

  body {
    min-width: ${zt.phoneSm};
  }

  body,
  button,
  input {
    font-family: ${({ theme: t }) => t.fontFamily};
    color: ${({ theme: t }) => t.colors.black10};
  }
  p,
  a,
  h1,
  h2,
  h3,
  h4,
  h5,
  input,
  hr,
  button,
  section,
  menu {
    margin: 0;
    padding: 0;
  }
  div,
  section,
  input,
  button {
    box-sizing: border-box;
  }
  input {
    outline: none;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    transition: background-color 100s ease-in-out 0s;
  }
  button {
    border: none;
  }
`;
const Ft = b`
  ${({ color: t, theme: o, disabled: n }) => {
  let r;
  return n ? r = typeof n == "string" ? o.colors[n] ?? n : o.colors.black80 : t && vt(o, t) ? r = o.colors[t] : r = t || o.colors.icon, b`
      fill: ${r};
      stroke: ${r};
    `;
}};

  g {
    fill: inherit;
    stroke: inherit;
  }

  *:not([stroke]) {
    &[fill='none'] {
      stroke-width: 0;
    }
  }

  *[stroke*='#'],
  *[STROKE*='#'] {
    stroke: inherit;
    fill: none;
  }

  *[fill-rule],
  *[FILL-RULE],
  *[fill*='#'],
  *[FILL*='#'] {
    stroke: none;
  }

  *[fill-rule],
  *[FILL-RULE],
  *[fill*='#']:not([fill='#FFF']),
  *[FILL*='#']:not([FILL='#FFF']) {
    fill: inherit;
  }
`, C = 24, Lt = (t) => {
  const o = t.match(/\d+(\.\d+)?/);
  return o ? parseFloat(o[0]) : C;
}, Bt = i.svg`
  display: inline-block;
  flex: 0 0 auto;
  ${({ size: t = C, theme: o, viewBox: n }) => {
  const [, , r, s] = (n || `0 0 ${C} ${C}`).split(
    " "
  ), a = +r / +s, l = Lt(o.icons.size[t] || `${t}px`);
  return r < s ? `
      width: ${l}px;
      height: ${l / a}px;
    ` : s < r ? `
      width: ${l * a}px;
      height: ${l}px;
    ` : `
      width: ${l}px;
      height: ${l}px;
    `;
}}
  ${({ $hasOwnColorPattern: t }) => t ? void 0 : Ft};
`, L = ({ a11yTitle: t, ...o }) => /* @__PURE__ */ e(Bt, { ...o, name: t, "data-name": "hn-icon" }), U = (t) => /* @__PURE__ */ e(L, { viewBox: "0 0 24 24", a11yTitle: "VisibilityOff", ...t, children: /* @__PURE__ */ e(
  "path",
  {
    d: "M12 6.5C14.76 6.5 17 8.74 17 11.5C17 12.01 16.9 12.5 16.76 12.96L19.82 16.02C21.21 14.79 22.31 13.25 23 11.49C21.27 7.11 17 4 12 4C10.73 4 9.51 4.2 8.36 4.57L10.53 6.74C11 6.6 11.49 6.5 12 6.5ZM2.71 3.16C2.32 3.55 2.32 4.18 2.71 4.57L4.68 6.54C3.06 7.83 1.77 9.53 1 11.5C2.73 15.89 7 19 12 19C13.52 19 14.97 18.7 16.31 18.18L19.03 20.9C19.42 21.29 20.05 21.29 20.44 20.9C20.83 20.51 20.83 19.88 20.44 19.49L4.13 3.16C3.74 2.77 3.1 2.77 2.71 3.16ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 10.73 7.18 10 7.49 9.36L9.06 10.93C9.03 11.11 9 11.3 9 11.5C9 13.16 10.34 14.5 12 14.5C12.2 14.5 12.38 14.47 12.57 14.43L14.14 16C13.49 16.32 12.77 16.5 12 16.5ZM14.97 11.17C14.82 9.77 13.72 8.68 12.33 8.53L14.97 11.17Z",
    fill: "#0091DF"
  }
) });
U.displayName = "VisibilityOff";
const H = (t) => /* @__PURE__ */ e(L, { viewBox: "0 0 24 24", a11yTitle: "VisibilityOn", ...t, children: /* @__PURE__ */ e(
  "path",
  {
    d: "M12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 8.74 9.24 6.5 12 6.5C14.76 6.5 17 8.74 17 11.5C17 14.26 14.76 16.5 12 16.5ZM12 8.5C10.34 8.5 9 9.84 9 11.5C9 13.16 10.34 14.5 12 14.5C13.66 14.5 15 13.16 15 11.5C15 9.84 13.66 8.5 12 8.5Z",
    fill: "#0091DF"
  }
) });
H.displayName = "VisibilityOn";
const K = (t) => /* @__PURE__ */ e(L, { viewBox: "0 0 24 24", a11yTitle: "Warning", ...t, children: /* @__PURE__ */ e(
  "path",
  {
    d: "M3.49492 22.105H20.5052C22.2446 22.105 23.3289 20.2187 22.4592 18.7165L13.9541 4.0217C13.0844 2.51947 10.9157 2.51947 10.046 4.0217L1.54089 18.7165C0.671174 20.2187 1.75549 22.105 3.49492 22.105ZM12.0001 15.1985C11.3788 15.1985 10.8706 14.6902 10.8706 14.069V9.81C10.8706 9.18877 11.3788 8.6805 12.0001 8.6805C12.6213 8.6805 13.1296 9.18877 13.1296 9.81V14.069C13.1296 14.6902 12.6213 15.1985 12.0001 15.1985ZM13.1296 17.587C13.1296 18.2108 12.6239 18.7165 12.0001 18.7165C11.3763 18.7165 10.8706 18.2108 10.8706 17.587C10.8706 16.9632 11.3763 16.4575 12.0001 16.4575C12.6239 16.4575 13.1296 16.9632 13.1296 17.587Z",
    fill: "#0091DF"
  }
) });
K.displayName = "Warning";
function _(t) {
  return (t == null ? void 0 : t.text) !== void 0;
}
function q(t) {
  return `${t || ""}${Math.random().toFixed(8).slice(2)}`;
}
const N = {
  xLarge: `
    padding: 16px 40px;
    font-size: 20px;
    line-height: 32px;
  `,
  large: `
    padding: 16px 30px;
    font-size: 18px;
    line-height: 24px;
  `,
  medium: `
    padding: 12px 22px;
    font-size: 16px;
    line-height: 24px;
  `,
  small: `
    padding: 8px 20px;
    font-size: 14px;
    line-height: 24px;
  `,
  xSmall: `
    padding: 8px 16px;
    font-size: 12px;
    line-height: 16px;
  `
}, It = i.button`
  --button-text-color: ${({ theme: t }) => t.colors.black100};
  --button-hover-text-color: ${({ theme: t }) => t.colors.black100};
  --button-disabled-text-color: ${({ theme: t }) => t.colors.black100};
  --button-bg-color: ${({ theme: t }) => t.colors.blue60};
  --button-hover-bg-color: ${({ theme: t }) => t.colors.blue50};
  --button-disabled-bg-color: ${({ theme: t }) => t.colors.black80};

  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: fit-content;
  border-radius: 8px;
  border: none;
  font-weight: 700;
  cursor: pointer;
  outline: none;
  white-space: nowrap;
  user-select: none;
  height: fit-content;
  font-family: inherit;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  color: var(--button-text-color);
  background: var(--button-bg-color);

  [data-name='hn-icon'] {
    fill: var(--button-text-color);
  }

  ${({ size: t }) => N[t] ?? N.small};

  &:focus-visible {
    outline: auto;
    background: var(--button-hover-bg-color);
    color: var(--button-hover-text-color);

    [data-name='hn-icon'] {
      fill: var(--button-hover-text-color);
    }
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background: var(--button-hover-bg-color);
      color: var(--button-hover-text-color);

      [data-name='hn-icon'] {
        fill: var(--button-hover-text-color);
      }
    }
  }

  &:disabled {
    background: var(--button-disabled-bg-color);
    color: var(--button-disabled-text-color);
    cursor: not-allowed;

    [data-name='hn-icon'] {
      fill: var(--button-disabled-text-color);
    }
  }

  ${({ $fit: t }) => t && b`
      width: fit-content;
      height: fit-content;
    `};
`, Ot = i.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  & > svg {
    margin-left: ${({ $margin: t, $position: o }) => o === "left" ? 0 : `${t}px`};
    margin-right: ${({ $margin: t, $position: o }) => o === "right" ? 0 : `${t}px`};
  }
`, Z = ({ position: t, Icon: o, size: n }) => {
  const r = Mt[n], s = ["small", "xSmall"].includes(n) ? 4 : 8;
  return o ? /* @__PURE__ */ e(Ot, { $position: t, $margin: s, children: /* @__PURE__ */ e(o, { size: r }) }) : null;
}, p = c(
  ({
    size: t = "medium",
    disabled: o = !1,
    onClick: n,
    children: r,
    LeftIcon: s,
    RightIcon: a,
    tabIndex: l,
    fit: d = !1,
    name: x,
    value: h,
    className: u,
    type: $ = "button",
    ...v
  }, z) => /* @__PURE__ */ f(
    It,
    {
      size: t,
      disabled: o,
      onClick: n,
      tabIndex: l,
      $fit: d,
      name: x,
      value: h,
      className: u,
      type: $,
      ref: z,
      ...v,
      children: [
        /* @__PURE__ */ e(Z, { Icon: s, size: t, position: "left" }),
        r,
        /* @__PURE__ */ e(Z, { Icon: a, size: t, position: "right" })
      ]
    }
  )
), Mt = {
  xLarge: 32,
  large: 32,
  medium: 24,
  small: 16,
  xSmall: 16
}, St = i(p)`
  --button-text-color: ${({ theme: t }) => t.colors.black100};
  --button-hover-text-color: ${({ theme: t }) => t.colors.black100};
  --button-bg-color: ${({ theme: t }) => t.colors.blue60};
  --button-hover-bg-color: ${({ theme: t }) => t.colors.blue50};
`;
c(({ as: t, ...o }, n) => /* @__PURE__ */ e(St, { ref: n, forwardedAs: t, ...o }));
const Nt = i(p)`
  --button-bg-color: ${({ theme: t }) => t.colors.darkBlue40};
  --button-hover-bg-color: ${({ theme: t }) => t.colors.darkBlue30};
`;
c((t, o) => /* @__PURE__ */ e(Nt, { ref: o, ...t }));
const Zt = i(p)`
  --button-bg-color: ${({ theme: t }) => t.colors.purple40};
  --button-hover-bg-color: ${({ theme: t }) => t.colors.purple30};
`;
c((t, o) => /* @__PURE__ */ e(Zt, { ref: o, ...t }));
const Vt = i(p)`
  --button-text-color: ${({ theme: t }) => t.colors.blue50};
  --button-hover-text-color: ${({ theme: t }) => t.colors.blue30};
  --button-disabled-text-color: ${({ theme: t }) => t.colors.black80};
  --button-bg-color: transparent;
  --button-hover-bg-color: transparent;
  --button-disabled-bg-color: transparent;
`, Dt = c((t, o) => /* @__PURE__ */ e(Vt, { ref: o, ...t })), jt = i(Dt)`
  padding: 0;
  border-radius: 0;
`, At = c((t, o) => /* @__PURE__ */ e(jt, { ref: o, ...t })), Pt = i(p)`
  --button-text-color: ${({ theme: t }) => t.colors.blue60};
  --button-hover-text-color: ${({ theme: t }) => t.colors.blue50};
  --button-disabled-text-color: ${({ theme: t }) => t.colors.black80};
  --button-bg-color: transparent;
  --button-hover-bg-color: transparent;
  --button-disabled-bg-color: transparent;

  padding: 0;
`, Wt = c(({ children: t, ...o }, n) => /* @__PURE__ */ e(Pt, { ref: n, "aria-label": "icon-button", ...o, fit: !0, children: t })), Et = i(p)`
  --button-text-color: ${({ theme: t }) => t.colors.darkBlue40};
  --button-hover-text-color: ${({ theme: t }) => t.colors.darkBlue30};
  --button-disabled-text-color: ${({ theme: t }) => t.colors.black80};
  --button-bg-color: transparent;
  --button-hover-bg-color: transparent;
  --button-disabled-bg-color: transparent;

  padding: 0;
`;
c(({ children: t, ...o }, n) => /* @__PURE__ */ e(Et, { ref: n, ...o, fit: !0, children: t }));
const Rt = i(p)`
  --button-text-color: ${({ theme: t }) => t.colors.purple40};
  --button-hover-text-color: ${({ theme: t }) => t.colors.purple30};
  --button-disabled-text-color: ${({ theme: t }) => t.colors.black80};
  --button-bg-color: transparent;
  --button-hover-bg-color: transparent;
  --button-disabled-bg-color: transparent;

  padding: 0;
`;
c(({ children: t, ...o }, n) => /* @__PURE__ */ e(Rt, { ref: n, ...o, fit: !0, children: t }));
const Gt = i(p)`
  --button-text-color: ${({ theme: t }) => t.colors.blue50};
  --button-hover-text-color: ${({ theme: t }) => t.colors.blue30};
  --button-bg-color: ${({ theme: t }) => t.colors.blue95};
  --button-hover-bg-color: ${({ theme: t }) => t.colors.blue90};
`;
c((t, o) => /* @__PURE__ */ e(Gt, { ref: o, ...t }));
const Ut = i(p)`
  --button-text-color: ${({ theme: t }) => t.colors.blue95};
  --button-hover-text-color: ${({ theme: t }) => t.colors.blue90};
  --button-disabled-text-color: ${({ theme: t }) => t.colors.black80};
  --button-bg-color: transparent;
  --button-hover-bg-color: transparent;
  --button-disabled-bg-color: transparent;

  padding: 0;
`;
c(({ children: t, ...o }, n) => /* @__PURE__ */ e(Ut, { ref: n, ...o, fit: !0, children: t }));
const J = i(At)`
  font-weight: 400;
  font-size: 13px;
  line-height: 1;

  ${({ theme: t, $danger: o }) => o && b`
      --button-text-color: ${t.colors.red60};
      --button-hover-text-color: ${t.colors.red40};
    `};
`, Q = b`
  &,
  &:focus,
  &:focus-visible,
  &:hover {
    border-color: ${({ theme: t }) => t.colors.red60};
  }
`, X = i.input`
  width: 100%;
  padding: ${P}px;
  background: ${({ theme: t }) => t.colors.black100};
  border: 1px solid ${({ theme: t }) => t.colors.black60};
  border-radius: 8px;
  outline: none;
  ${W}

  ::placeholder {
    color: ${({ theme: t }) => t.colors.black60};
  }

  &:focus,
  &:focus-visible,
  &:hover {
    border: 1px solid ${({ theme: t }) => t.colors.blue60};
  }

  &:disabled {
    background: ${({ theme: t }) => t.colors.black95};
    border: 1px solid ${({ theme: t }) => t.colors.black60};
    user-select: none;
  }

  &[aria-invalid='true'] {
    ${Q}
  }

  box-sizing: border-box;
`, Ht = i.textarea`
  width: 100%;
  padding: ${P}px;
  background: ${({ theme: t }) => t.colors.black100};
  border: 1px solid ${({ theme: t }) => t.colors.black60};
  border-radius: 8px;
  resize: ${({ $resizable: t }) => t ? "both" : "none"};
  ${W}

  ::placeholder {
    color: ${({ theme: t }) => t.colors.black60};
  }

  &:focus,
  &:focus-visible,
  &:hover {
    border-color: ${({ theme: t }) => t.colors.blue60};
    outline: 0px;
  }

  &:disabled {
    background: ${({ theme: t }) => t.colors.black95};
    border-color: ${({ theme: t }) => t.colors.black60};
    user-select: none;
  }

  &[aria-invalid='true'] {
    ${Q}
  }

  box-sizing: border-box;
`, Kt = i.div`
  width: 100%;
`, _t = i(K).attrs({ color: "red50" })`
  width: 16px;
  height: 16px;
  margin-right: 8px;
`, y = c(
  ({
    value: t,
    placeholder: o,
    label: n,
    option: r,
    render: s,
    compact: a,
    onChange: l,
    onKeyUp: d,
    onError: x,
    onValid: h,
    onValidation: u,
    autofocus: $,
    alt: v,
    disabled: z,
    validation: B,
    type: tt,
    readOnly: ot,
    minLength: et,
    maxLength: nt,
    max: rt,
    min: it,
    step: lt,
    validateOnMount: I = !0,
    name: st,
    autocomplete: at,
    id: ct,
    defaultValue: bt,
    ...dt
  }, ut) => {
    const O = V(ct || q("textfield-")), [g, pt] = T(null), [k, M] = T(!1), xt = gt(
      (ft) => {
        l == null || l(ft), k || M(!0);
      },
      [k, l]
    );
    w(() => {
      (I || t) && (!I && t && console.warn(
        "TextField: validation on mount is enabled, because value is defined"
      ), M(!0));
    }, []), w(() => {
      k && pt(Xt({ value: t, validation: B }));
    }, [k, B, t]);
    const m = (g == null ? void 0 : g.isError) || !1;
    w(() => {
      m ? x == null || x() : h == null || h();
    }, [m, h, x]), w(() => {
      u == null || u(t, !m);
    }, [m, t, u]);
    const ht = typeof n == "string" ? n : void 0, S = {
      id: O.current,
      placeholder: o,
      value: t,
      onChange: xt,
      onKeyUp: d,
      autoFocus: $,
      disabled: z,
      alt: v,
      "aria-invalid": m,
      "aria-label": ht,
      type: tt,
      readOnly: ot,
      minLength: et,
      maxLength: nt,
      min: it,
      max: rt,
      step: lt,
      name: st,
      autoComplete: at,
      defaultValue: bt
    };
    return /* @__PURE__ */ f(Kt, { ...dt, children: [
      /* @__PURE__ */ e(
        Qt,
        {
          label: n,
          option: r,
          compact: a,
          inputId: O.current
        }
      ),
      (s == null ? void 0 : s(S)) ?? /* @__PURE__ */ e(X, { ref: ut, ...S }),
      /* @__PURE__ */ e(
        qt,
        {
          isError: m,
          errorText: g == null ? void 0 : g.errorText,
          compact: a
        }
      )
    ] });
  }
);
y.displayName = "TextFieldBase";
const qt = ({
  errorText: t,
  compact: o,
  isError: n
}) => n && !!t && (!o || o !== "bottom") ? /* @__PURE__ */ e(wt, { children: n && /* @__PURE__ */ f(Ct, { children: [
  /* @__PURE__ */ e(_t, {}),
  /* @__PURE__ */ e(yt, { children: t })
] }) }) : null, Jt = (t) => _(t) ? {
  optionText: t.text,
  onOptionClick: t.onClick,
  optionDanger: t.danger
} : { optionText: t }, Qt = ({
  label: t,
  option: o,
  compact: n,
  inputId: r
}) => {
  if (!(t || o || !n || n !== "top")) return null;
  const { optionText: a, onOptionClick: l, optionDanger: d } = Jt(o);
  return /* @__PURE__ */ f(F, { children: [
    /* @__PURE__ */ e(D, { children: t && /* @__PURE__ */ e(
      j,
      {
        as: "label",
        "data-testid": "label",
        "data-id": "label",
        htmlFor: r,
        children: t
      }
    ) }),
    /* @__PURE__ */ e(A, { children: o && /* @__PURE__ */ e(
      J,
      {
        onClick: l,
        "data-testid": "option",
        "data-id": "option",
        $danger: d,
        children: a
      }
    ) })
  ] });
}, Xt = ({
  value: t,
  validation: o
}) => {
  if (!o || typeof t != "string" && t !== void 0) return;
  const n = Array.isArray(o) ? [...o] : [o];
  for (let r = 0; r < n.length; r++) {
    const { errorText: s, validate: a } = n[r];
    let l = !1;
    if (typeof a == "string" ? l = !Yt[a](t) : typeof a == "boolean" ? l = !a : l = !a(t), l) return { isError: l, errorText: s };
  }
}, Yt = {
  email: $t,
  positiveIntegerOrZero: kt
}, to = c(
  (t, o) => /* @__PURE__ */ e(y, { ref: o, ...t })
);
to.displayName = "TextField";
const oo = c(
  (t, o) => /* @__PURE__ */ e(y, { ...t, ref: o, compact: !0 })
);
oo.displayName = "TextFieldCompact";
const eo = i(Wt)`
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  right: 10px;
`, no = i.div`
  position: relative;
  width: 100%;
`, ro = i(y)`
  & input {
    padding-right: 40px;
  }
`, Y = c(
  ({ isPasswordVisible: t, onClick: o, autocomplete: n, ...r }, s) => /* @__PURE__ */ f(no, { children: [
    /* @__PURE__ */ e(X, { ref: s, autoComplete: n, ...r }),
    /* @__PURE__ */ e(
      eo,
      {
        "data-testid": "toggler",
        onClick: () => o(!t),
        children: t ? /* @__PURE__ */ e(H, { size: 16 }) : /* @__PURE__ */ e(U, { size: 16 })
      }
    )
  ] })
);
Y.displayName = "InputWithToggler";
const io = c(
  (t, o) => {
    const [n, r] = T(!1);
    return /* @__PURE__ */ e(
      ro,
      {
        ...t,
        "data-testid": "textbox-password",
        type: n ? "text" : "password",
        render: (s) => /* @__PURE__ */ e(
          Y,
          {
            ref: o,
            isPasswordVisible: n,
            onClick: r,
            ...s
          }
        )
      }
    );
  }
);
io.displayName = "PasswordTextField";
const lo = i.div`
  width: 100%;
`, so = c(
  ({
    value: t = "",
    label: o,
    option: n,
    compact: r,
    autofocus: s,
    className: a,
    resizable: l,
    id: d,
    ...x
  }, h) => {
    const u = V(d || q("textarea-")), $ = typeof o == "string" ? o : void 0;
    return /* @__PURE__ */ f(lo, { className: a, children: [
      /* @__PURE__ */ e(
        co,
        {
          label: o,
          option: n,
          compact: r,
          inputId: u.current
        }
      ),
      /* @__PURE__ */ e(
        Ht,
        {
          value: t,
          autoFocus: s,
          "aria-label": $,
          $resizable: l,
          ref: h,
          id: u.current,
          ...x
        }
      )
    ] });
  }
);
so.displayName = "TextAreaField";
const ao = (t) => _(t) ? {
  optionText: t.text,
  onOptionClick: t.onClick,
  optionDanger: t.danger
} : { optionText: t }, co = ({
  label: t,
  option: o,
  compact: n,
  inputId: r
}) => {
  if (!(t || o || !n)) return null;
  const { optionText: a, onOptionClick: l, optionDanger: d } = ao(o);
  return /* @__PURE__ */ f(F, { children: [
    /* @__PURE__ */ e(D, { children: t && /* @__PURE__ */ e(
      j,
      {
        as: "label",
        "data-testid": "label",
        "data-id": "label",
        htmlFor: r,
        children: t
      }
    ) }),
    /* @__PURE__ */ e(A, { children: o && /* @__PURE__ */ e(
      J,
      {
        onClick: l,
        "data-testid": "option",
        "data-id": "option",
        $danger: d,
        children: a
      }
    ) })
  ] });
};
export {
  io as PasswordTextField,
  so as TextAreaField,
  to as TextField,
  oo as TextFieldCompact
};
